import React from 'react';
import dayjs from 'dayjs';
import PropTypes from 'prop-types';
import { Typography, Timeline, Card } from 'antd';
import { CardTitle } from '../../../../../components/CardTitle/CardTitle';

const { Text } = Typography;

const HistoryInfoCards = ({ t, pensioner }) => (
  <Card
    title={<CardTitle icon="clock">{t('owners.show.history_info')}</CardTitle>}
  >
    <Timeline
      style={{
        maxHeight: '400px',
        overflowY: 'scroll',
        width: '100%'
      }}
    >
      {(pensioner?.history || []).map((event) => {
        const formattedDate = dayjs(event.date).format('DD/MM/YYYY à HH:mm');

        return (
          <Timeline.Item
            style={{
              marginTop: '10px'
            }}
            key={`${event.type}-${formattedDate}`}
          >
            <Text>{t(`history.${event.type}`)}</Text>
            <br />
            <Text type="secondary" italic style={{ color: 'grey' }}>
              {t('history.item', {
                first_name: event?.by?.first_name || '',
                last_name: event?.by?.last_name || '',
                date: formattedDate
              })}
            </Text>
          </Timeline.Item>
        );
      })}
    </Timeline>
  </Card>
);

export default HistoryInfoCards;

HistoryInfoCards.propTypes = {
  t: PropTypes.func.isRequired,
  pensioner: PropTypes.shape({
    history: PropTypes.arrayOf(PropTypes.shape({}))
  }).isRequired
};
